import React, { useContext } from 'react';
import { FaShoppingBag, FaSignOutAlt, FaUserCircle } from 'react-icons/fa';
import { Link, NavLink } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { BasketContext } from '../contexts/BasketContext';

function Navbar() {
    const { itemCount, total } = useContext(BasketContext);
    const { isAuthenticated, signOut, user } = useContext(AuthContext);
    const isAdmin = ['admin', 'superadmin'].includes(user?.role);

    return (
        <header className="site-header">
            <div className="site-header__inner">
                <Link className="brand" to="/" aria-label="Divine Veg on 262 home">
                    <img src={`${process.env.PUBLIC_URL}/menu-images/divine-veg-262-logo.webp`} alt="" />
                    <span>Divine Veg <b>on 262</b></span>
                </Link>
                <nav className="primary-nav" aria-label="Primary navigation">
                    <NavLink exact to="/" activeClassName="is-active">Menu</NavLink>
                    <NavLink to="/about-us" activeClassName="is-active">Our kitchen</NavLink>
                    <NavLink to="/contact-us" activeClassName="is-active">Contact</NavLink>
                    {isAuthenticated && <NavLink to="/orders" activeClassName="is-active">My orders</NavLink>}
                    {isAdmin && <NavLink to="/kitchen" activeClassName="is-active">Operations</NavLink>}
                </nav>
                <div className="header-actions">
                    {isAuthenticated ? (
                        <button className="header-account" onClick={signOut} title="Sign out" aria-label="Sign out"><FaSignOutAlt /></button>
                    ) : (
                        <Link className="header-account" to="/sign-in" title="Sign in" aria-label="Sign in"><FaUserCircle /></Link>
                    )}
                    <Link className="header-basket" to="/checkout" aria-label={`View basket, ${itemCount} items`}>
                        <FaShoppingBag /><span className="header-basket__label">Basket</span><span className="header-basket__count">{itemCount}</span><strong>R{total.toFixed(2)}</strong>
                    </Link>
                </div>
            </div>
        </header>
    );
}

export default Navbar;
